<template>
	<div class="preloader">
		<video
			ref="videoRef"
			class="preloader__video"
			playsinline
			autoplay
			muted
			loop
			preload="auto"
			@loadeddata="onVideoReady"
			@error="onVideoError"
		>
			<!-- 			:poster="posterSrc" -->
			<source
				:src="webmSrc"
				type="video/mp4"
			/>
			<!-- <source :src="fallbackSrc" type="video/mp4" v-if="fallbackSrc"> -->
			<!-- Fallback для браузеров без поддержки WebM -->
			<!-- <img :src="posterSrc" alt="Loading animation"> -->
		</video>

		<!-- Показ скелетона пока видео грузится -->
		<!-- <div
			v-if="!isVideoReady && !hasError"
			class="preloader__skeleton"
		></div> -->
	</div>
</template>

<script setup lang="ts">
	import webmVideo from '/Loading_car.mp4';

	const webmSrc = webmVideo;
	const videoRef = ref<HTMLVideoElement | null>(null);
	const isVideoReady = ref(false);
	const hasError = ref(false);
	const isPlaying = ref(false);

	// const posterSrc = posterImage;
	// const fallbackSrc = mp4Video; // раскомментировать если есть MP4

	const onVideoReady = () => {
		isVideoReady.value = true;
		console.log('WebM video loaded and ready');

		// Пытаемся воспроизвести (autoplay может не сработать без взаимодействия)
		if (videoRef.value) {
			videoRef.value
				.play()
				.then(() => {
					isPlaying.value = true;
				})
				.catch((e) => {
					console.warn('Autoplay blocked:', e);
					// Показываем кнопку play если нужно
				});
		}
	};

	const onVideoError = (e: Event) => {
		hasError.value = true;
		console.error('WebM video error:', e);
	};

	const tryPlayVideo = async () => {
		if (!videoRef.value || isPlaying.value) return;

		try {
			await videoRef.value.play();
			isPlaying.value = true;
		} catch (error) {
			console.warn('Video play failed:', error);
		}
	};

	// Автоматический перезапуск если видео остановилось
	const checkVideoStatus = () => {
		if (videoRef.value && !videoRef.value.paused && !isPlaying.value) {
			isPlaying.value = true;
		}
	};

	onMounted(() => {
		// Проверяем статус видео
		const interval = setInterval(checkVideoStatus, 1000);

		// Очистка при размонтировании
		onUnmounted(() => {
			clearInterval(interval);
			if (videoRef.value) {
				videoRef.value.pause();
				videoRef.value.currentTime = 0;
			}
		});
	});
</script>

<style scoped lang="scss">
	.preloader {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 999999;
		background-color: var(--bg-primary, #ffffff);

		&__video {
			width: min(200px, 80vw);
			height: min(200px, 80vh);
			object-fit: contain;
			opacity: 1;
			transition: opacity 0.3s ease-in-out;
			border-radius: 50%;
			overflow: hidden;

			&::-webkit-media-controls {
				display: none !important;
			}
		}

		&__skeleton {
			width: 200px;
			height: 200px;
			background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
			background-size: 200% 100%;
			animation: loading 1.5s infinite;
			border-radius: 8px;
			position: absolute;
		}

		// Кнопка play если autoplay заблокирован
		&__play-button {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 60px;
			height: 60px;
			border-radius: 50%;
			background: rgba(0, 122, 255, 0.9);
			border: none;
			color: white;
			font-size: 24px;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: all 0.2s;
			z-index: 2;

			&:hover {
				background: rgba(0, 122, 255, 1);
				transform: translate(-50%, -50%) scale(1.05);
			}

			&:after {
				content: '▶';
				margin-left: 3px;
			}
		}

		// Сообщение об ошибке
		&__error {
			text-align: center;
			color: var(--text-secondary, #666);
			font-size: 14px;

			&:before {
				content: '⚠️';
				font-size: 32px;
				display: block;
				margin-bottom: 10px;
			}
		}
	}

	@keyframes loading {
		0% {
			background-position: 200% 0;
		}
		100% {
			background-position: -200% 0;
		}
	}
</style>
